// extracted by mini-css-extract-plugin
module.exports = {"LevelScore":"LevelScore_LevelScore__NCJZw","LevelScore__block":"LevelScore_LevelScore__block__fGA2c","LevelScore_default":"LevelScore_LevelScore_default__hheof"};